import React, { memo, useEffect, useRef } from 'react';
import { View, ActivityIndicator, StyleSheet, Animated, Easing } from 'react-native';
import { COLORS } from '@bcm/constants';

import commonStyles from './styles/common';
import Icon from './icon/Icon';
import IconMap from './icon/IconMap';

const LoadingWheel = ({
	backgroundColor,
	size = 'large',
	style,
}) => {
	const styles = StyleSheet.create({
		centered: {
			...commonStyles.containers.center,
			backgroundColor: backgroundColor ? backgroundColor : undefined,
			...style
		}
	});

	const rotation = useRef(new Animated.Value(0)).current; // Use useRef to persist the animation value

	useEffect(() => {
		// Configure and start the rotation animation
		Animated.loop(
			Animated.timing(rotation, {
				toValue: 1, // Final value of rotation
				duration: 2000, // Duration of one rotation
				easing: Easing.linear, // Linear easing for smooth rotation
				useNativeDriver: true, // Use native driver for better performance
			}),
		).start();
	}, [rotation]);

	const animatedStyle = {
		transform: [
			{
				rotate: rotation.interpolate({
					inputRange: [0, 1],
					outputRange: ['0deg', '360deg'], // Interpolate rotation value between 0 and 360 degrees
				}),
			},
		],
	};

	return (
		<View style={styles.centered}>
			{typeof size === 'string' && <ActivityIndicator
				size={size}
				color={COLORS.primary}
			/>}
			{typeof size === 'number' && <Animated.View style={animatedStyle}>
				<Icon
					icon={IconMap.loading}
					color={COLORS.primary}
					size={size}
				/>
			</Animated.View>}
		</View>
	);
};

export default memo(LoadingWheel);
